import { render, staticRenderFns } from "./OrderNavigation.vue?vue&type=template&id=450b1e2a&"
import script from "./OrderNavigation.vue?vue&type=script&lang=js&"
export * from "./OrderNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports